<script setup lang="ts">
import RevolveLight from '@/svg/logo/full/revolve-labs-logo-black.svg'
import RevolveDark from '@/svg/logo/full/revolve-labs-logo-white.svg'
import { useDark } from '@vueuse/core'

const isDark = useDark()
</script>

<template>
  <el-card class="login-card">
    <template #header>
      <RevolveDark v-if="isDark" />
      <RevolveLight v-else />
    </template>
    <div class="login-card__body">
      <slot />
    </div>
  </el-card>
</template>

<style scoped lang="scss">
.login-card {
  height: auto;
  width: 480px;
  margin-bottom: 25%;
  justify-content: center;

  &__body {
    display: flex;
    flex-direction: column;
    gap: var(--spacing-spacing-lg);
  }
}

:deep(.el-card__header) {
  border-bottom: 0;
}
</style>
